<template>
	<!-- 考试倒计时 -->
	<div class="content">
		<!-- TAB栏 -->
		<el-header>
			<div class="Left">
				<p>理论考试</p>
				<p class="logoh1">Mock examination</p>
			</div>
			<div class="Right" @click="FAuni">
				<span class="iconfont">&#xe641;</span>
				<span class="iconHome">返回首页</span>
			</div>
		</el-header>
		<!-- 内容 -->
		<el-main>
			<!-- 头部背景 -->
			<!-- <div class="timeTips">
            <div class="delete">距离考试结束还剩</div>
            <div class="Tips">
            {{countdown}}
            </div>
        </div> -->
			<div class="shiti">
				<el-carousel height="490px" :autoplay="false" indicator-position="none" arrow="always" ref="carousel">
					<el-carousel-item v-for="(item,i) in subjectList" :key="i">
						<div class="exam_item">
							<div class="exam_title">
								（{{i+1}} {{item.classification}} {{item.score}} 分）{{item.title}}
							</div>
							<div slot="reference" @click="select({item, optionItem})" v-for="optionItem in item.options"
								:key="optionItem.length">
								<div class="exam_option" v-if="optionItem.name">
									<template v-if="choice[item.id] && choice[item.id][optionItem.order]">
										<div class="exam_option_label choice">{{optionItem.order}} </div>
									</template>
									<template v-else>
										<div class="exam_option_label">{{optionItem.order}} </div>
									</template>
									<div class="nande">{{optionItem.name}}</div>
								</div>
							</div>
							<div v-if="choice[item.id]" class="kists">
								题目解析:{{subjectList[i].analysis}}；正确答案:{{subjectList[i].answer}}</div>
							<!-- <div v-if="choice[item.id]" class="kists"></div> -->
							<!-- <div v-if="choice[item.id] && confirmSelect" class="tbs"></div> -->
						</div>
					</el-carousel-item>
				</el-carousel>
				<div class="list">
					<ul>
						<li @click="submit">
							<image src="../../static/img/too.png" mode=""></image>
							<div>提交</div>
						</li>
					</ul>
				</div>
			</div>
			<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
				<span>是否确认提交试卷</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitHandle">确 定</el-button>
				</span>
			</el-dialog>
		</el-main>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				Ianalysis: [],
				value: '',
				dialogVisible: false,
				countdown: '',
				questionList: [],
				resultShow: false,
				isshow: true,
				choice: {}, // 选择的答案
				current: 0,
				subjectList: [],
				sid: '', // 试卷id
				choose: '', // 题id
				cid: '', // 结果id
				chooses: {},
				defen: 0, // 得分
				Antithesis: 0, // 答对的提数
				lecturer: 0, // 错题数
				addForm: {
					number: 0,
					fraction: 0,
					examinationTime: '',
					times: ''
				},
				transft: '',
				intervalFlag: "",
				curSelect: [] ,//当前已选项
				confirmSelect: false,
			}
		},
		created(option) {
			this.transformation()
			this.addtime();
			this.qwe();
			this.thiTime();
		},
		methods: {
			// 转换考试内容
			transformation() {
				if (this.$route.query.Icurriculum == 'bld') {
					this.transft = '便民超市'
				} else if (this.$route.query.Icurriculum == 'cydcf') {
					this.transft = '餐饮店厨房'
				} else if (this.$route.query.Icurriculum == 'czw') {
					this.transft = '居住出租屋'
				} else if (this.$route.query.Icurriculum == 'tzsb') {
					this.transft = '特种设备'
				} else if (this.$route.query.Icurriculum == 'dg') {
					this.transft = '施工用电安全'
				} else if (this.$route.query.Icurriculum == 'gjaq') {
					this.transft = '国家安全'
				} else if (this.$route.query.Icurriculum == 'jzsgaq') {
					this.transft = '建筑工地安全'
				} else if (this.$route.query.Icurriculum == 'jxl') {
					this.transft = '教学楼安全'
				} else if (this.$route.query.Icurriculum == 'kyz') {
					this.transft = '客运车安全'
				} else if (this.$route.query.Icurriculum == 'rq') {
					this.transft = '燃气安全'
				} else if (this.$route.query.Icurriculum == 'aqsc') {
					this.transft = '生产车间'
				} else if (this.$route.query.Icurriculum == 'spxzf') {
					this.transft = '食品加工小作坊'
				} else if (this.$route.query.Icurriculum == 'fank') {
					this.transft = '反恐防暴'
				} else if (this.$route.query.Icurriculum == 'tzc') {
					this.transft = '童装厂'
				} else if (this.$route.query.Icurriculum == 'wb') {
					this.transft = '网吧'
				} else if (this.$route.query.Icurriculum == 'wc') {
					this.transft = '重点车辆安全'
				} else if (this.$route.query.Icurriculum == 'xc') {
					this.transft = '校车安全'
				} else if (this.$route.query.Icurriculum == 'xyjws') {
					this.transft = '校园警务室'
				} else if (this.$route.query.Icurriculum == 'xj') {
					this.transft = '防范邪教'
				} else if (this.$route.query.Icurriculum == 'xsss') {
					this.transft = '学生宿舍'
				// } else if (this.$route.query.Icurriculum == 'yjjy') {
				// 	this.transft = '应急救援'
				} else if (this.$route.query.Icurriculum == 'yjaq') {
					this.transft = '寄递安全'
				} else if (this.$route.query.Icurriculum == 'stzl') {
					this.transft = '生态治理'
				} else if (this.$route.query.Icurriculum == 'weih') {
					this.transft = '危化企业'
				} else if (this.$route.query.Icurriculum == 'sd') {
					this.transft = '书店'
				}
				console.log('this.transft', this.transft);
			},
			thiTime() {
				var aData = new Date();
				// console.log('aData', aData) //Wed Aug 21 2019 10:00:58 GMT+0800 (中国标准时间)

				this.value =
					aData.getFullYear() + "年" + (aData.getMonth() + 1) + "月" + aData.getDate() + "日" + aData.getHours() +
					"：" + aData.getMinutes();
				// console.log('thiTime this.value', this.value)
			},
			async addtime() {
				const {
					data: res
				} = await this.$http.get('examTime');
				let time = res[0].state * 60;
				const that = this
				this.intervalFlag = setInterval(function() {
					time = time - 1;
					const minute = parseInt(time / 60);
					const second = parseInt(time % 60);
					that.countdown = (minute + ':' + second);
					if (that.countdown === '0:0') {
						// window.sessionStorage.clear();
						// that.goRedirects()
						// that.asd()
					}
				}, 1000);
			},

			// 跳转
			goRedirects() {
				this.$router.push('/home')
			},
			//拉取考题
			async qwe() {
				let number = this.$route.query.number
				console.log('number', number);
				
				const {
					data: appointmentid
				} = await this.$http.get(`/appointmentid/${number}`);
				
				console.log('res=>',appointmentid)
				
				if(!appointmentid || appointmentid.length<1){
					this.$message.error('没有该预约，请进行预约!')
					return false
				}
				
				const curriculum = appointmentid[0].curriculum
				const that = this
				const {
					data: res
				} = await this.$http.post('/subjectssTheory', {
					curriculum : curriculum
				});
				const data = that.getRandomArrayElements(res, 100)
				console.log('data', data)
				
				that.questionList = data
				for (let var1 in data) {
					let answers = []
					let stdAnswer = data[var1].answer.split(',')

					stdAnswer.forEach(a => {
						switch (a) {
							case 1:
							case "1":
								answers.push('A')
								break
							case 2:
							case "2":
								answers.push('B')
								break
							case 3:
							case "3":
								answers.push('C')
								break
							case 4:
							case "4":
								answers.push('D')
								break
							default:
								break
						}
					})
					
					this.subjectList.push({
						id: data[var1].id,
						category_id: data.length,
						classification: data[var1].classification,
						title: data[var1].ask,
						A: data[var1].A,
						B: data[var1].B,
						C: data[var1].C,
						D: data[var1].D,
						answer: answers, //正确答案
						score: 1, // 分数
						options: [{
							name: data[var1].A,
							order: "A",
							heide: 0,
							answer: 0
						}, {
							name: data[var1].B,
							order: "B",
							heide: 0,
							answer: 0
						}, {
							name: data[var1].C,
							order: "C",
							heide: 0,
							answer: 0
						}, {
							name: data[var1].D,
							order: "D",
							heide: 0,
							answer: 0
						}]
					})
				}
				// console.log('this.questionList', this.questionList)
				console.log('this.subjectList', this.subjectList)
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done()
					})
					.catch(_ => {})
			},
			//答案
			select({
				item,
				optionItem: {
					order
				}
			}) {
				let choose = order
				this.choose = item.id
				this.confirmSelect = false
				
				let chooses = this.choice
				if (item.answer.length > 1) {
					if(!chooses[item.id] || chooses[item.id]=== undefined || chooses[item.id]===null){
						chooses[item.id] = {}
					}
				}else{
					chooses = {}
					chooses[item.id] = {}
				}
				
				for (var i in item.options) {
					if(item.options[i].order==choose){
						let key = item.options[i].order
						if(!chooses[item.id][key]){
							chooses[item.id][key] = true
						}else{
							chooses[item.id][key] = false
						}
					}
				}
				
				this.$set(this.choice, item.id, chooses[item.id])
				this.$forceUpdate();
				
				console.log('this.choice', this.choice)
				
				//当前得分情况
				this.statisticScore(item)
				
				
				return false
				
				// this.$messagebox.confirm('是否确认该选项?', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	//点击确定的操作(调用接口)
				// 	if (item.answer.lastIndexOf(choose) !== -1) {
				// 		this.defen = Number(this.defen) + Number(item.score)
				// 		this.Antithesis = Number(this.Antithesis) + Number(1)
				// 	} else {
				// 		this.defen = Number(this.defen) + Number(0)
				// 		this.Antithesis = Number(this.Antithesis) + Number(0)
				// 		this.lecturer = Number(this.lecturer) + Number(1)
				// 		this.Ianalysis.push(item.id)
				// 	}
				// 	var chooses = {}
				// 	for (var i in item.options) {
				// 		this.chooses[item.options[i].order] = false
				// 	}
				// 	chooses[choose] = true
					
				// 	console.log('chooses', chooses)
					
				// 	this.$set(this.choice, item.id, chooses)
				// 	this.$forceUpdate();
				// }).catch(() => {
				// 	//几点取消的提示
				// 	this.$message.success('取消题目选项！')
				// })
				// this.$refs.carousel.next();
			},
			statisticScore(item){
				let select = this.choice[item.id]
				let us = []
				
				for(let k in select){
					if(select[k]){
						us.push(k)
					}
				}
				
				let answer = item.answer.sort().join('')
				us = us.sort().join('')
				this.curSelect[item.id] = 0
				if(answer===us){
					this.curSelect[item.id] = item.score
				}
				
				console.log('us=>', us)
				console.log('answer', item.answer)
				console.log('this.curSelect', this.curSelect)
			},
			//多选
			selectMulti(item){
				this.confirmSelect = true
				console.log(item)
			},

			submit(e) {
				this.dialogVisible = true
			},
			//统计最终得分
			clacScore(){
				let score = 0;
				this.Antithesis = this.lecturer = 0
				this.Ianalysis = []
				this.curSelect.forEach((v, k)=>{
					//v 做题得分 k题目ID
					console.log('k, v', k, v)
					score += v
					
					if(v>0){
						this.Antithesis = Number(this.Antithesis) + Number(1)
					}else{
						this.lecturer = Number(this.lecturer) + Number(1)
						this.Ianalysis.push(k)
					}
					
					// if (item.answer.lastIndexOf(choose) !== -1) {
					// 	this.defen = Number(this.defen) + Number(item.score)
					// 	this.Antithesis = Number(this.Antithesis) + Number(1)
					// } else {
					// 	this.defen = Number(this.defen) + Number(0)
					// 	this.Antithesis = Number(this.Antithesis) + Number(0)
					// 	this.lecturer = Number(this.lecturer) + Number(1)
					// 	this.Ianalysis.push(item.id)
					// }
					
				})
				this.defen = score;
			},
			
			async asd() {
				// TODO 提交成绩时才计算最后总得分
				this.clacScore()
				
				this.resultShow = true
				this.addForm.number = this.$route.query.number
				this.addForm.fraction = `实训考试${this.transft}：` + (this.defen)
				// 开考时间
				this.addForm.times = this.value
				// 考试用时
				this.addForm.examinationTime = this.time_to_sec()
				console.log(this.addForm);
				await this.$http.post(
					"fraction/establish", this.addForm
				);
				// this.dialogVisible = false
				this.analysiss()
				setTimeout(() => {
					this.choices()
				}, 100);
			},
			// 再次选择
			choices() {
				this.$router.replace('/test')
			},
			FAuni() {
				window.sessionStorage.clear();
				localStorage.removeItem("userInfo");
				this.$router.push('/home')
			},
			// 随机
			getRandomArrayElements(arr, count) {
				const shuffled = []
				const indexArr = this.getRandomGroup(arr, count)

				console.log('indexArr', indexArr)

				for (let i = 0; i < indexArr.length; i++) {
					shuffled.push(arr[indexArr[i]])
				}

				return shuffled
			},
			getRandomGroup(arr, num) {
				const randArr = []
				num = num > 0 ? num : 10
				if (num > arr.length) {
					num = arr.length
				}

				while (randArr.length < num) {
					let n = this.randomNum(1, arr.length) - 1

					if (randArr.indexOf(n) == -1) {
						randArr.push(n)
					}
				}
				return randArr
			},
			//获取指定范围内的随机数
			randomNum(minNum, maxNum) {
				switch (arguments.length) {
					case 1:
						return parseInt(Math.random() * minNum + 1, 10);
						break;
					case 2:
						return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
						break;
			  default:
						return 0;
						break;
				}
			},

			// 时间转换为秒
			// time_to_sec() {
			// 	var s = '';
			// 	var min = this.countdown.split(':')[0];
			// 	var sec = this.countdown.split(':')[1];
			// 	s = Number(min*60) + Number(sec);
			// 	const ss = 1800 - s
			// 	const minute=parseInt(ss/60);
			//     const second=parseInt(ss%60);
			//     const to_time = (minute+':'+second);
			// 	return to_time;
			// },

			// async analysiss () {
			// 	await this.$http.post(
			//         "analysis/establish", {uname: this.transft, Isid: this.Ianalysis, number: this.$route.query.number}
			//     ); 
			// }

			submitHandle() {
				this.$router.back();
			}

		},
		beforeDestroy() {
			if (this.intervalFlag) {
				clearInterval(this.intervalFlag); //关闭
			} //利用vue的生命周期函数
		}
	}
</script>

<style lang="less" scoped>
	// 引入swiper css
	.iconfont {
		font-size: 50px;
		color: cornflowerblue;
		padding-left: 16px;
	}

	.kists {
		color: #999;
		font-size: 24px;
		margin-top: 5%;
	}

	.el-main .bgc {
		width: 37.9375rem;
		height: 36.6875rem;
		margin-top: 10rem;
		margin-right: 2rem;
	}

	.el-header {
		padding-top: 18px;
	}

	.el-header p {
		color: cornflowerblue;
		margin: 0 auto;
		font-size: 2em;
		font-weight: 600;
	}

	.el-header span {
		display: block;
	}

	.el-header .logoh1 {
		font-size: 0.9em;
		font-weight: 400;
		margin-left: 0.1875rem;
		margin-top: -0.25rem;
	}

	.el-header {
		//   margin: 1.25rem 0;
		margin: 15px;
		margin-top: 0px;
		display: flex;
		justify-content: space-between;
	}

	.Right {
		margin-right: 6.25rem;
		margin-top: -0.7rem;
	}

	.iconHome {
		font-size: 22px;
		color: cornflowerblue;
	}

	.bg-set {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;
	}

	div {
		color: #000;
	}

	.timeTips {
		position: absolute;
		top: 3%;
		left: 50%;
		transform: translateX(-50%);
	}

	.delete {
		color: #999;
		font-size: 20px;
		text-align: center;
		letter-spacing: 15px;
	}

	.Tips {
		color: #999;
		font-size: 25px;
		text-align: center;
		font-weight: 700;
		letter-spacing: 25px;
	}

	.title {
		width: 100%;
		text-align: center;
		margin: 5% 0;
	}

	text {
		padding-left: 30%;
		padding-top: 5%;
		padding-bottom: 3%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	radio {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 1%;
	}

	.titleID {
		margin: 0 auto;
		text-align: center;
		line-height: 70px;
		width: 140px;
		height: 140px;
		border-radius: 140px;
		background-color: cadetblue;
	}

	button {
		background-color: cornflowerblue;
		color: #fff;
	}

	.el-button {
		padding: 14px 20px;
		font-size: 15px;
		border-radius: 2px;
	}

	* {
		margin: 0;
		padding: 0;
	}

	li {
		list-style-type: none;
	}

	.shiti {
		width: 100%;
		height: 100%;
	}

	.tbs {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		z-index: 99999;
	}

	.option {
		float: left;
		width: 100%;
		height: 100%;
		position: relative;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.home {
		float: left;
		width: 30%;
		height: 60px;
		line-height: 60px;
		font-size: 30px;
		color: #333;
		border-bottom: 1px solid #E5E5E5;
		margin-left: 35%;
	}

	.home span {
		float: left;
	}

	.list {
		position: relative;
		bottom: 1%;
		width: 100%;
		height: 60px;
		z-index: 100;
	}

	.list ul li {
		float: left;
		margin-left: 50%;
		transform: translateX(-50%);
		width: 50%;
		text-align: center;
		height: 60px;
		line-height: 60px;
		font-size: 30px;
		color: #fff;
		background-color: rgb(18, 187, 255);
		border-radius: 30px;
	}

	ul li div {
		color: #fff;
	}

	.list ul li image {
		float: left;
		width: 36px;
		height: 36px;
		margin-left: 33px;
		// margin-top: 40px;
	}

	.list ul li:nth-child(2) {
		float: right;
	}

	.examTopImg {
		width: 100%;
		height: 136px;
	}

	.exam_item {
		padding-top: 22px;
		padding-left: 170px;
		/*设置内边距不撑开外框 */
		box-sizing: border-box;
	}

	.exam_item .exam_title {
		color: #000;
		font-size: 24px;
		line-height: 30px;
		margin-bottom: 10px;
	}

	.exam_item .exam_option {
		float: left;
		width: 100%;
		font-size: 18px;
		color: #999999;
		padding-left: 142px;
		line-height: 40px;
		/* display: flex; */
		align-items: center;
		margin-top: 10px;
		padding: 10px;
		border-radius: 14px;
		z-index: 99;
	}

	.exam_item .exam_option .exam_option_label {
		float: left;
		width: 40px;
		height: 40px;
		border: 1px solid rgba(227, 227, 227, 1);
		border-radius: 50%;
		line-height: 40px;
		text-align: center;
		margin-right: 20px;
		/* // color: #e3e3e3; */
	}

	.exam_item .confirm_choice a {
		float: left;
		width: 200px;
		font-size: 26px;
		padding: 16px 20px;
		text-align: center;
		border: 1px solid #c3c3c3;
		border-radius: 10px;
	}

	.nande {
		float: left;
		width: 85%;
	}

	.choice {
		color: #ffffff;
		background-color: darkgray;
		/* // border:1px solid rgba(227,227,227,1); */
	}

	.examBottom {
		/* display: flex;
		align-items: center; */
		/*定义body的元素垂直居中*/
		/* // justify-content: center; */
		/*定义body的里的元素水平居中*/
		border-top: 1upx solid #E5E5E5;
		width: 100%;
		height: 116px;
		position: fixed;
		margin-top: 116px;
		bottom: 0;
		background: #fff;
		/* justify-content: space-between;
		 */
	}

	.examBottom image {
		width: 36px;
		height: 36px;
		margin-left: 33px;
	}

	.examBottom>div:nth-child(2) {
		margin: 0px 40px 0px auto;
	}

	/deep/.el-carousel__arrow {
		height: 100px;
		width: 100px;
		;
	}

	/deep/.el-icon-arrow-left:before {
		font-size: 40px;
	}

	/deep/.el-icon-arrow-right:before {
		font-size: 40px;
	}
</style>
